import { useState } from "react";
import { Box, Button, Checkbox, Dialog, FormControlLabel, IconButton, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { RegisterFormField } from "../../../../payment.types";
import { PaymentPopUpCloseIcon } from "../../../../../../assets/icons/MUI/PaymentIcons";

const AddCustomFieldPopUp = ({
  onClose,
  open,
  onDone,
}: {
  open: boolean;
  onClose: () => void;
  onDone: (field: RegisterFormField) => void;
}) => {
  const { t } = useTranslation();

  const [title, setTitle] = useState("");
  const [required, setRequired] = useState(false);

  const handleDone = () => {
    const newField: RegisterFormField = {
      title,
      required,
      isCustom: true,
    };

    onDone(newField);
    setTitle("");
    setRequired(false);
    onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "640px",
          borderRadius: "12px",
          padding: "24px",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          paddingBottom: "16px",
          borderBottom: "1px solid #E4E7EC",
          textAlign: "center",
        }}
      >
        <Typography component="h3" sx={{ color: "#101828", fontSize: "18px", fontWeight: 600 }}>
          {t("pages.payment.createPaymentLink.addField")}
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: "16px",
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <PaymentPopUpCloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ marginTop: "24px", display: "flex", flexDirection: "column", gap: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            rowGap: "8px",
          }}
        >
          <Typography
            sx={{
              color: "#344054",
              fontFamily: "Montserrat",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "20px",
            }}
          >
            {t("pages.payment.createPaymentLink.defaultInput")}
          </Typography>
          <TextField variant="outlined" fullWidth value={title} onChange={(e) => setTitle(e.target.value)} />
        </Box>
        <FormControlLabel
          control={<Checkbox checked={required} onChange={(e) => setRequired(e.target.checked)} />}
          label={t("pages.payment.createPaymentLink.required")}
        />
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "24px" }}>
        <Button variant="outlined-md" onClick={onClose}>
          {t("pages.payment.createPaymentLink.cancel")}
        </Button>
        <Button variant="primary-md" onClick={handleDone} disabled={!title.trim()}>
          {t("pages.payment.createPaymentLink.done")}
        </Button>
      </Box>
    </Dialog>
  );
};

export default AddCustomFieldPopUp;
